module.exports = __webpack_public_path__ + "img/site-category.61193191.svg";